export const NARRATIVE_EASTER_EGG_FEATURE_FLAG = "narrative-easter-egg";

export function isNarrativeEasterEggEnabled(
  featureFlags?: string[] | null,
): boolean {
  return (featureFlags ?? []).includes(NARRATIVE_EASTER_EGG_FEATURE_FLAG);
}
